import { getParentOrigin } from './parent-origin';

/**
 * Host (BIG) mount path for the embedded chat. BIG serves the chat under /ai and
 * mounts the chat's own route after it, e.g. /ai/thread-shared/<token> loads the
 * chat at /thread-shared/<token>. Must match the BIG route
 * (big3-mono-repo/Frontend/src/app/ai/[[...path]]/page.tsx).
 */
const HOST_AI_MOUNT_PATH = '/ai';

/** The chat's own shared-thread route, mounted under the host path above. */
const SHARED_THREAD_ROUTE = 'thread-shared';

/**
 * Decide which URL to show/copy for a freshly created share link.
 *
 * When the chat runs standalone, the backend-built `shareUrl`
 * (`{chat-origin}/thread-shared/{token}`) is correct. When the chat is embedded
 * inside a host (BIG) — either the report sidebar or the full-page /ai — that
 * bare chat-origin URL is not reachable for end users, since the chat only lives
 * inside the host's iframe. In that case we rewrite the link to a host deep link
 * (`{host-origin}/ai/thread-shared/{token}`) that the host mounts into its
 * embedded chat.
 *
 * "Embedded" is detected via the host origin captured from parent postMessages
 * (see parent-origin.ts); a standalone chat has no parent and falls back to the
 * backend URL.
 */
export function buildShareUrl(
    token: string | undefined,
    fallbackShareUrl: string
): string {
    const parentOrigin = getParentOrigin();
    if (token && parentOrigin) {
        return `${parentOrigin}${HOST_AI_MOUNT_PATH}/${SHARED_THREAD_ROUTE}/${encodeURIComponent(
            token
        )}`;
    }
    return fallbackShareUrl;
}
